// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3bkB-","addWidgetButton":"Header_addWidgetButton__2xwbV","dashboardTabs":"Header_dashboardTabs__6qZ4n","active":"Header_active__3RrE3"};